function p(l, t) {
  return t = t || {}, new Promise(function(f, d) {
    var e = new XMLHttpRequest(), u = [], a = [], s = {}, i = function() {
      return { ok: (e.status / 100 | 0) == 2, statusText: e.statusText, status: e.status, url: e.responseURL, text: function() {
        return Promise.resolve(e.responseText);
      }, json: function() {
        return Promise.resolve(e.responseText).then(JSON.parse);
      }, blob: function() {
        return Promise.resolve(new Blob([e.response]));
      }, clone: i, headers: { keys: function() {
        return u;
      }, entries: function() {
        return a;
      }, get: function(n) {
        return s[n.toLowerCase()];
      }, has: function(n) {
        return n.toLowerCase() in s;
      } } };
    };
    for (var c in e.open(t.method || "get", l, !0), e.onload = function() {
      e.getAllResponseHeaders().replace(/^(.*?):[^\S\n]*([\s\S]*?)$/gm, function(n, r, o) {
        u.push(r = r.toLowerCase()), a.push([r, o]), s[r] = s[r] ? s[r] + "," + o : o;
      }), f(i());
    }, e.onerror = d, e.withCredentials = t.credentials == "include", t.headers) e.setRequestHeader(c, t.headers[c]);
    e.send(t.body || null);
  });
}
export {
  p as default
};
//# sourceMappingURL=index49.js.map
